import { render, staticRenderFns } from "./SettingsMenuAsideComponent.vue?vue&type=template&id=6dcd183c&scoped=true"
import script from "./SettingsMenuAsideComponent.vue?vue&type=script&lang=js"
export * from "./SettingsMenuAsideComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcd183c",
  null
  
)

export default component.exports